var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup172(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_172",
    "data-name": "Group 172",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.39,
    height: 25.39,
    viewBox: "0 0 25.39 25.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M-504.587,234.688a10.319,10.319,0,0,1-4.4-1.1,23.686,23.686,0,0,1-7.037-5.324,20.913,20.913,0,0,1-4.167-6.157,11.265,11.265,0,0,1-.93-4.381,4.79,4.79,0,0,1,4.771-4.525,2.285,2.285,0,0,1,2.163,1.626c.4,1.2.794,2.4,1.2,3.6a1.935,1.935,0,0,1-.517,2.193c-.369.353-.72.726-1.087,1.081a.228.228,0,0,0-.059.315,12.58,12.58,0,0,0,5.9,5.938.262.262,0,0,0,.364-.057c.283-.3.59-.581.874-.883a1.932,1.932,0,0,1,2.022-.564c1.372.348,2.741.707,4.119,1.028A2.065,2.065,0,0,1-499.7,229.3a4.106,4.106,0,0,1-1.176,3.577,5.448,5.448,0,0,1-2.62,1.657A6.936,6.936,0,0,1-504.587,234.688Z",
    transform: "translate(521.119 -209.298)",
    fill: "#039511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M-314.708,153.2a4.433,4.433,0,0,1-.052.576,1.255,1.255,0,0,1-1.334,1,1.271,1.271,0,0,1-1.158-1.258,10.936,10.936,0,0,0-.839-4.27,11.237,11.237,0,0,0-8.466-6.946,13.42,13.42,0,0,0-2.044-.206,1.308,1.308,0,0,1-1.345-1.3,1.283,1.283,0,0,1,1.361-1.245,13.964,13.964,0,0,1,13.544,11.056c.175.85.252,1.721.374,2.582Z",
    transform: "translate(340.056 -139.553)",
    fill: "#039511"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M-319.874,244.275a1.349,1.349,0,0,1-.859,1.476,1.268,1.268,0,0,1-1.669-1.232,6.151,6.151,0,0,0-1.189-3.653,6.238,6.238,0,0,0-5.119-2.662,1.285,1.285,0,0,1-1.3-1.089,1.229,1.229,0,0,1,.82-1.352,2.557,2.557,0,0,1,.884-.079,8.879,8.879,0,0,1,7.989,6.108A8.9,8.9,0,0,1-319.874,244.275Z",
    transform: "translate(340.127 -230.594)",
    fill: "#039511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup172);
export default __webpack_public_path__ + "static/media/Group 172.8ba286634f3650548838de0fa57100ef.svg";
export { ForwardRef as ReactComponent };